import React from 'react';
import { Grid } from '@material-ui/core';

import { FormField } from 'core/components/form';
import { Card } from 'core/components/card';

import useStyles from './changes-for-approval-section.styles';

const PreAcceptChangesVerification = () => {
  const classes = useStyles();

  return (
    <Card type="primary" className={classes.descriptionOfPolicyChangesContainer}>
      <Grid className={classes.preAcceptChangesVerificationContainer}>
        <p>Before proceeding, please verify that:</p>
        <ul>
          <li>The policy qualifies for the PIP coverage option.</li>
          <li>Any added or removed drivers are accurately accounted for in changes to the PIP Household residents.</li>
          <li>
            All the necessary documents, such as proof of eligibility and the PIP Selection/Rejection form, have been
            provided and signed if needed.
          </li>
        </ul>
        <FormField
          mode="light"
          label="I confirm that I have verified the above."
          type="checkbox"
          id="preAcceptChangesVerification"
          name="preAcceptChangesVerification"
        />
      </Grid>
    </Card>
  );
};

export default PreAcceptChangesVerification;
